import { render, staticRenderFns } from "./PagePlanAlimentaireEdition.vue?vue&type=template&id=15432334&scoped=true&"
import script from "./PagePlanAlimentaireEdition.vue?vue&type=script&lang=js&"
export * from "./PagePlanAlimentaireEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15432334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15432334')) {
      api.createRecord('15432334', component.options)
    } else {
      api.reload('15432334', component.options)
    }
    module.hot.accept("./PagePlanAlimentaireEdition.vue?vue&type=template&id=15432334&scoped=true&", function () {
      api.rerender('15432334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Menus/PagePlanAlimentaireEdition.vue"
export default component.exports